module.exports = __webpack_public_path__ + "static/media/skill_graphicAndVideo.85d785be.png";